import React, { useState } from "react";

export const ElementByAnima = (): JSX.Element => {
  const cardWidthVW = 40; // Width of each card in viewport width
  const cardCount = 6;

  const [isPaused, setIsPaused] = useState(false);
  const cards = [1, 2, 3, 4, 5, 6];

  return (
    <section className="relative w-full min-h-screen bg-[#D4FFFD] py-12 md:py-24 px-4 md:px-16 lg:px-24 flex flex-col items-center justify-center">
      {/* Desktop: Static positioned cards */}
      {cards.map((num, index) => (
        <div
          key={`desktop-card-${num}`}
          className={`hidden lg:block absolute ${index === 0 ? "top-10 left-10" :
            index === 1 ? "top-10 right-10" :
              index === 2 ? "top-1/2 left-20 -translate-y-1/2" :
                index === 3 ? "top-1/2 right-20 -translate-y-1/2" :
                  index === 4 ? "bottom-10 left-10" : "bottom-10 right-10"}`}
        >
          <div className="border text-card-foreground bg-[#d9d9d9] rounded-2xl shadow-md w-[20vw] h-[25vh]">
            <img
              src={`/assets/Card${num}.png`}
              alt={`Card ${num}`}
              className="w-full h-full object-cover rounded-2xl"
            />
          </div>
        </div>
      ))}

      {/* Main content */}
      <div className="z-10 flex flex-col items-center gap-6 max-w-4xl text-center w-full">
        <div className="inline-flex items-center transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 shadow hover:bg-primary/80 bg-transparent border border-[#169C97] px-4 py-2 rounded-full text-[#169C97] text-xs font-bold">
          MEMORIES
        </div>
        <h2 className="font-bold text-2xl md:text-4xl lg:text-5xl text-[#1a1a1a] leading-tight">
          📸 Share Your Little <br />Explorer's Journey
        </h2>
        <div className="flex flex-wrap justify-center items-center gap-2 md:gap-4 text-xl md:text-2xl font-bold">
          <span className="text-[#26da47]">Upload</span>
          <span className="text-[#595959] hidden md:inline">•</span>
          <span className="text-[#ff037d]">Celebrate</span>
          <span className="text-[#595959] hidden md:inline">•</span>
          <span className="text-[#2ca7ff]">Inspire</span>
        </div>
        <p className="text-[#595959] text-sm md:text-base leading-6 max-w-2xl px-4 py-2 mt-6 mb-6">
          We love seeing how your little monsters bring their creativity to life — just scan any QR code from your kit to return here, upload your child's artwork or activity photos, rate your travel adventure, and leave a fun note about your experience!
        </p>

        {/* Mobile: Scrollable animated cards */}
        <div className="lg:hidden relative w-full overflow-x-auto touch-auto cursor-grab">
          <div
            className="flex gap-4 select-none"
            style={{
              animation: isPaused ? "none" : "scroll-left 15s linear infinite",
              width: `${cardCount * 2 * cardWidthVW}vw`,
            }}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            onTouchStart={() => setIsPaused(true)}
            onTouchEnd={() => setIsPaused(false)}
          >
            {[...cards, ...cards].map((num, idx) => (
              <div
                key={`${num}-${idx}`}
                className="border text-card-foreground bg-[#d9d9d9] rounded-2xl shadow-md flex-shrink-0"
                style={{ width: `${cardWidthVW}vw`, height: "30vw" }}
              >
                <img
                  src={`/assets/Card${num}.png`}
                  alt={`Card ${num}`}
                  className="w-full h-full object-cover rounded-2xl"
                />
              </div>
            ))}
          </div>
        </div>

        <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-gradient-to-r from-[#0B7E7A] to-[#003230] hover:bg-opacity-90 h-9 mt-2 px-6 py-3 rounded-full border border-[#bb7ce4] text-white shadow-[inset_0px_9px_19px_#a870cc33] hover:opacity-90">
          Upload Your Journey ✨
        </button>
      </div>

      {/* Animation Keyframes */}
      <style>{`
        @keyframes scroll-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </section>
  );
};
